import { useIsMobile } from "@/hooks/useIsMobile";
import StudentDashboard from "./StudentDashboard";
import MobileStudentHome from "./MobileStudentHome";

export default function StudentHome() {
  const isMobile = useIsMobile(768);
  return isMobile ? <MobileStudentHome /> : <StudentDashboard />;
}
